import React, { useState, useEffect, useMemo, useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import Button from "../../../../../components/Common/Button/Button";
import Input from "../../../../../components/Common/Input/Input";
import NextIcon from "../../../../../components/Common/SvgIcons/CommonIcons/NextIcon";
import InfoIcon from "../../../../../components/Common/SvgIcons/SocialIcons/InfoIcon";
import Tooltip from "../../../../../components/Common/ToolTip/Tooltip";
import { setErrorHandler } from "../../../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../../../utils/errorTypes";
import { useFetchData } from "../../../../../hooks/useFetchData";
import {
  availableTopicActionHandler,
  getAllGroupAfterSearchTopicsActionHandler,
  getAllTopicsActionHandler,
  getAllTopicsAfterSearchActionHandler,
  updateGroupTopicActionHandler,
} from "../../../../../store/actions/actionHandlers/organizeActionHandler";
import InfiniteScroll from "react-infinite-scroll-component";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { addGroupTopic } from "../../../../../utils/mainTabs/organize/addGroupTopic";
import {
  postImageActionHandler,
  addGroupTopicActionHandler,
} from "../../../../../store/actions/actionHandlers/organizeActionHandler";

import classes from "./TopicContent.module.scss";
import useHashArray from "../../../../../hooks/useHashArray";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { IoMdMove } from "react-icons/io";
import { topicManagement } from "../../../../../utils/mainTabs/organize/topicManagement";
import Loader from "../../../../../components/Common/Loader/Loader";
import { FormattedMessage } from "react-intl";

export const topicContentSchema = yup.object().shape({
  UserGroupDetails: yup
    .array(
      yup.object().shape({
        Training: yup.string(),
      })
    )
    .min(1, "Training is required!"),
});

const TopicContent = () => {
  const pageSize = 8;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const routerParams = useParams();
  // const [getAllTopics, setGetAllTopics] = useState([]);
  const [availableTopics, setAvailableTopics] = useState([]);
  const [topicsTraining, setTopicsTraining] = useState([]);
  const [selectedTopicData, setSelectedTopicData] = useState([]);
  const [selectedTopicIds, setSelectedTopicIds] = useState([]);
  const [movedTopicData, setMovedTopicData] = useState([]);
  const [movedTopicDataCount, setMovedTopicDataCount] = useState([]);
  const [activeLoader, setActiveLoader] = useState(false);
  const [loader, setLoader] = useState(true);
  const [selectedTpc, setSelectedTpc] = useState([]);
  const [callApi, setCallApi] = useState(true);
  const [btnLoader, setBtnLoader] = useState(false);
  const [publishBtnLoader, setPublishBtnLoader] = useState(false);

  const [searchText, setSearchText] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [topicIds, setTopicIds] = useState([]);

  const {
    formData,
    setFormData,
    pathType,
    getAllTopics,
    setGetAllTopics,
    createGroupTopicPath,
    createGroupTopicEditPath,
    dataForUpdateGroupTopicByID,
    tenantName,
  } = useOutletContext();
  // useEffect(() => {
  //   dispatch(availableTopicActionHandler("", 0, 8, setGetAllTopics));
  //   // setSelectedTopicData([]);
  // }, [dispatch, setSelectedTopicData]);
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(topicContentSchema),
    defaultValues: useMemo(() => {
      return {
        ...formData?.details,
        ...formData?.topicContent,
      };
    }, [formData?.details, formData?.topicContent]),
  });
  const {
    handleSubmit,
    formState: { errors, isValid, isDirty },
    reset,
    // watch,
    setValue,
  } = methods;
  const clearAll = () => {
    // reset(setSelectedTpc([]));
    // reset(setSelectedTopicData([]))
    // reset(setGetAllTopics([]))
  };

  const handleTopics = (e, data, index) => {
    if (e.target.checked === true) {
      // selectedTopicData.push(data);
      if (!selectedTopicData.find((item) => item.TopicId === data.TopicId)) {
        selectedTopicData.push(data);
      }
      selectedTopicIds.push(data.TopicId);
      const updatedData = getAllTopics?.map((item) => {
        if (item?.TopicId === data?.TopicId) {
          return { ...item, isChecked: true, disabled: false };
        } else return item;
      });
      setGetAllTopics(updatedData);
    } else {
      const updatedArr = selectedTopicData.filter(
        (dataVal) => dataVal.TopicId !== data.TopicId
      );
      setSelectedTopicData(updatedArr);
      const updatedData = getAllTopics?.map((item) => {
        if (item?.TopicId === data?.TopicId) {
          return { ...item, isChecked: false, disabled: false };
        } else return item;
      });
      setGetAllTopics(updatedData);
    }
  };
  const [isClick, setIsClick] = useState(false);
  const handleNextBtn = () => {
    // setIsClick(true);
    const updatedData = getAllTopics?.map((item) => {
      if (item?.isChecked) {
        return { ...item, disabled: true };
      } else return item;
    });
    setGetAllTopics(updatedData);
    setSelectedTpc((prev) => [...prev, ...selectedTopicData]);
    setSelectedTopicData([]);
  };
  const handleTrainingContent = (e, data) => {
    if (e.target.checked === true) {
      // if (movedTopicData.indexOf(data.TopicId || data.SubTopicId) === -1) {
      // }
      movedTopicData.push(data.TopicId || data.SubTopicId);
      const updateArray = selectedTpc.map((item) => {
        if (
          (item?.TopicId || item?.SubTopicId) ===
          (data?.TopicId || data?.SubTopicId)
        ) {
          return { ...item, isChecked: true };
        } else return item;
      });
      setSelectedTpc(updateArray);
    } else {
      const updatedArr = movedTopicData.filter(
        (dataVal) => dataVal !== (data.TopicId || data.SubTopicId)
      );
      setMovedTopicData(updatedArr);
      const updateArray = selectedTpc.map((item) => {
        if (
          (item?.TopicId || item?.SubTopicId) ===
          (data?.TopicId || data?.SubTopicId)
        ) {
          return { ...item, isChecked: false };
        } else return item;
      });
      setSelectedTpc(updateArray);
    }
  };
  const handlePrevBtn = () => {
    const updatedArr = getAllTopics.map((data) => {
      if (movedTopicData.includes(data.TopicId || data.SubTopicId)) {
        return { ...data, isChecked: false, disabled: false };
      } else return data;
    });
    setGetAllTopics(updatedArr);
    const updateRightData = selectedTpc.filter(
      (dataVal) =>
        !movedTopicData.includes(dataVal.TopicId || dataVal.SubTopicId)
    );
    setSelectedTpc(updateRightData);
    setMovedTopicData([]);
  };
  useEffect(() => {
    if (formData?.details?.thumbnailImageFile.length == "1") {
      // const formImgData = new FormData();:?.details?.thumbnailImageFile?.[0]);}
      dispatch(
        postImageActionHandler(
          formData?.details?.thumbnailImageFile,
          setImageUrl
        )
      ).then((response) => {
        if (response) {
          setLoader(false);
        }
      });
    }
  }, [setImageUrl]);
  const [prevPageTrue, setPrevPageTrue] = useState(false);
  const handleCancelBtn = () => {
    setPrevPageTrue(true);
    const updatedArr = getAllTopics?.map((data) => {
      if (data?.isChecked) {
        return { ...data, isChecked: true, disabled: true };
      } else return data;
    });
    setGetAllTopics(updatedArr);
    // reset(setGetAllTopics(updatedArr));
    setGetAllTopics([]);
    setFormData((formData) => {
      return {
        ...formData,
        prevPageTrue,
        topicContent: {
          ...formData.topicContent,
          TopicCourseAssociations: elementsSelectedTopic,
        },
      };
    });
  };

  useEffect(() => {
    if (getAllTopics?.length === 0 && callApi)
      dispatch(
        getAllTopicsAfterSearchActionHandler(
          searchText,
          0,
          pageSize,
          setGetAllTopics
        )
      );
  }, [getAllTopics?.length && callApi]);

  const onSubmit = (data) => {
    setPublishBtnLoader(true);
    if (pathType === "edit") {
      // console.log("selected", selectedTpc);
      let grpTopicSubTopicAssociations = elementsSelectedTopic?.map((item) => {
        return {
          Description: item?.Description,
          GroupTopicId: dataForUpdateGroupTopicByID?.[0]?.Id,
          // ImageUrl:
          //   formData.details.thumbnailImageFile.length !== "1"
          //     ? formData.details.thumbnailImageFile
          //     : imageUrl,
          ImageUrl:
            formData.details.thumbnailImageFile.length == "1"
              ? imageUrl
              : formData.details.thumbnailImageFile,
          Name: item?.Name,
          SubTopicId: item?.SubTopicId ? item?.SubTopicId : item?.TopicId,
          TenantId: item?.TenantId,
        };
      });
      let updateDataOnEdit = {
        CreateByUserId: dataForUpdateGroupTopicByID?.[0]?.CreateByUserId,
        CreatedBy: dataForUpdateGroupTopicByID?.[0]?.CreatedBy,
        CreatedOn: dataForUpdateGroupTopicByID?.[0]?.CreatedOn,
        Description: formData?.details?.description,
        GroupTopicSubTopicAssociations: grpTopicSubTopicAssociations,
        GroupTopicUsergroupAssociations:
          formData?.details?.UserGroupDetails?.map((addgrpTopicID) => {
            addgrpTopicID.GroupTopicId = dataForUpdateGroupTopicByID?.[0]?.Id;
            return addgrpTopicID;
          }),
        Id: dataForUpdateGroupTopicByID?.[0]?.Id,
        // ImageUrl: dataForUpdateGroupTopicByID?.[0]?.ImageUrl
        //   ? dataForUpdateGroupTopicByID?.[0]?.ImageUrl
        //   : imageUrl,
        ImageUrl:
          formData.details.thumbnailImageFile.length == "1"
            ? imageUrl
            : formData.details.thumbnailImageFile,
        IsNewGroup: dataForUpdateGroupTopicByID?.[0]?.IsNewGroup,
        IsPublished: dataForUpdateGroupTopicByID?.[0]?.IsPublished
          ? "false"
          : "true",
        IsRestrictedAccess:
          dataForUpdateGroupTopicByID?.[0]?.IsRestrictedAccess,
        ModifiedBy: dataForUpdateGroupTopicByID?.[0]?.ModifiedBy,
        ModifiedOn: dataForUpdateGroupTopicByID?.[0]?.ModifiedOn,
        Name: formData?.details?.name,
        SubTopics: [],
        TenantId: 0,
      };
      dispatch(updateGroupTopicActionHandler(updateDataOnEdit)).then(
        (response) => {
          if (response) {
            dispatch(
              setErrorHandler(
                errorTypes.SUCCESS,
                `Topic 
            ${
              dataForUpdateGroupTopicByID?.[0]?.IsPublished
                ? " UnPublished "
                : " Published"
            } Successfully`
              )
            );
            setPublishBtnLoader(false);
            navigate(
              `${addGroupTopic.path(
                location,
                routerParams,
                tenantName
              )}/publishGroupTopic`
            );
          }
        }
      );
    } else {
      setFormData((formData) => {
        return {
          ...formData,
          details: {
            ...formData.details,
            thumbnailImageFile: imageUrl,
          },
          topicContent: {
            ...formData.topicContent,
            training: selectedTpc,
          },
        };
      });
      let grpTopicSubTopicAssociations = elementsSelectedTopic?.map((item) => {
        return {
          Description: item?.Description,
          ImageUrl: item?.ImageUrl,
          Name: item?.Name,
          SubTopicId: item?.TopicId,
          TenantId: item?.TenantId,
        };
      });
      let postData = {
        Description: formData.details.description,
        GroupTopicId: 0,
        GroupTopicSubTopicAssociations: grpTopicSubTopicAssociations,
        GroupTopicUsergroupAssociations: formData.details.UserGroupDetails.map(
          (addTenantId) => {
            addTenantId.TenantId = formData.details.tenantId;
            return addTenantId;
          }
        ),
        ImageUrl: imageUrl,
        IsPublished: data.publishbtn ? true : false,
        IsRestrictedAccess: true,
        Name: formData.details.name,
        TopicCourseAssociations: [],
      };
      // console.log(postData);
      dispatch(addGroupTopicActionHandler(postData)).then((response) => {
        if (
          response.status === 200 &&
          response.data !== "Topic Name already exists"
        ) {
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Topic created successfully")
          );
          setPublishBtnLoader(false);
          navigate(
            `${addGroupTopic.path(
              location,
              routerParams,
              tenantName
            )}/publishGroupTopic`
          );
        } else if (
          response.status === 200 &&
          response.data === "Topic Name already exists"
        ) {
          setPublishBtnLoader(false);
          dispatch(setErrorHandler(errorTypes.FAIL, response.data));
        }
      });
    }
  };
  const saveTopic = () => {
    setBtnLoader(true);
    setPublishBtnLoader(false);
    if (pathType === "edit") {
      let grpTopicSubTopicAssociations = elementsSelectedTopic?.map((item) => {
        return {
          Description: item?.Description,
          GroupTopicId: dataForUpdateGroupTopicByID?.[0]?.Id,
          ImageUrl:
            formData.details.thumbnailImageFile.length == "1"
              ? imageUrl
              : formData.details.thumbnailImageFile,
          Name: item?.Name,
          SubTopicId: item?.SubTopicId ? item?.SubTopicId : item?.TopicId,
          TenantId: item?.TenantId,
        };
      });
      let updateDataOnEdit = {
        CreateByUserId: dataForUpdateGroupTopicByID?.[0]?.CreateByUserId,
        CreatedBy: dataForUpdateGroupTopicByID?.[0]?.CreatedBy,
        CreatedOn: dataForUpdateGroupTopicByID?.[0]?.CreatedOn,
        Description: formData?.details?.description,
        GroupTopicSubTopicAssociations: grpTopicSubTopicAssociations,
        GroupTopicUsergroupAssociations:
          formData?.details?.UserGroupDetails?.map((addgrpTopicID) => {
            addgrpTopicID.GroupTopicId = dataForUpdateGroupTopicByID?.[0]?.Id;
            return addgrpTopicID;
          }),
        Id: dataForUpdateGroupTopicByID?.[0]?.Id,
        ImageUrl:
          formData.details.thumbnailImageFile.length == "1"
            ? imageUrl
            : formData.details.thumbnailImageFile,
        IsNewGroup: dataForUpdateGroupTopicByID?.[0]?.IsNewGroup,
        IsPublished: dataForUpdateGroupTopicByID?.[0]?.IsPublished,
        IsRestrictedAccess:
          dataForUpdateGroupTopicByID?.[0]?.IsRestrictedAccess,
        ModifiedBy: dataForUpdateGroupTopicByID?.[0]?.ModifiedBy,
        ModifiedOn: dataForUpdateGroupTopicByID?.[0]?.ModifiedOn,
        Name: formData?.details?.name,
        SubTopics: [],
        TenantId: 0,
      };
      dispatch(updateGroupTopicActionHandler(updateDataOnEdit)).then(
        (response) => {
          if (response) {
            dispatch(
              setErrorHandler(errorTypes.SUCCESS, "Topic updated successfully")
            );
            setBtnLoader(false);
            navigate(`${topicManagement.path(tenantName)}`);
          } else if (
            response?.status === 200 &&
            response.data === "Topic Name already exists"
          ) {
            setPublishBtnLoader(false);
            setBtnLoader(false);
            dispatch(setErrorHandler(errorTypes.FAIL, response.data));
          }
        }
      );
    } else {
      let grpTopicSubTopicAssociations = elementsSelectedTopic?.map((item) => {
        return {
          Description: item?.Description,
          ImageUrl: item?.ImageUrl,
          Name: item?.Name,
          SubTopicId: item?.TopicId,
          TenantId: item?.TenantId,
        };
      });
      setFormData((formData) => {
        return {
          ...formData,
          details: {
            ...formData.details,
            thumbnailImageFile: imageUrl,
          },
          topicContent: {
            ...formData.topicContent,
            training: selectedTpc,
          },
        };
      });
      let postData = {
        Description: formData.details.description,
        GroupTopicId: 0,
        GroupTopicSubTopicAssociations: grpTopicSubTopicAssociations,
        GroupTopicUsergroupAssociations: formData.details.UserGroupDetails.map(
          (addTenantId) => {
            addTenantId.TenantId = formData.details.tenantId;
            return addTenantId;
          }
        ),
        ImageUrl: imageUrl,
        IsPublished: false,
        IsRestrictedAccess: true,
        Name: formData.details.name,
        TopicCourseAssociations: [],
      };
      dispatch(addGroupTopicActionHandler(postData)).then((response) => {
        if (
          response.status === 200 &&
          response.data !== "Topic Name already exists"
        ) {
          dispatch(
            setErrorHandler(errorTypes.SUCCESS, "Topic Created successfully")
          );
          setLoader(false);
          setBtnLoader(false);
          navigate(`${topicManagement.path(tenantName)}`);
        } else if (
          response.status === 200 &&
          response.data === "Topic Name already exists"
        ) {
          setPublishBtnLoader(false);
          setBtnLoader(false);
          dispatch(setErrorHandler(errorTypes.FAIL, response.data));
        }
      });
    }
  };

  const [topicCourseAss, setTopicCourseAss] = useState();
  const [topicCourseAssTopicId, setTopicCourseAssTopicId] = useState();

  const { hashTable: topicCourseAssTopicIdList } = useHashArray(
    topicCourseAssTopicId,
    "TopicId",
    true
  );
  const { hashTable: selectedTopicItemsList } = useHashArray(
    selectedTpc,
    "TopicId",
    true
  );
  const { hashTable: topicCourseAssList } = useHashArray(
    topicCourseAss,
    "SubTopicId",
    true
  );
  const { hashTable: subTopicItemsList } = useHashArray(
    selectedTpc,
    "SubTopicId",
    true
  );
  const [selctedAllTopicsIds, setSelctedAllTopicsIds] = useState(
    selectedTopicItemsList
  );
  const [selectedTopicItemsIDs, setSelectedTopicItemsIDs] = useState([]);
  // useEffect(() => {
  //   if (topicCourseAss?.length > 0) {
  //     let arr = [];
  //     selectedTpc.forEach((item) => {
  //       arr.push(item?.SubTopicId);
  //     });
  //     setTop
  //   }
  // }, [topicCourseAss?.length]);
  useEffect(() => {
    const mergedTopicsId = { ...selectedTopicItemsList, ...subTopicItemsList };
    setSelctedAllTopicsIds(mergedTopicsId);
  }, [selectedTopicItemsList]);
  useEffect(() => {
    if (formData?.topicContent?.TopicCourseAssociations) {
      const updatedData = formData?.topicContent?.TopicCourseAssociations?.map(
        (item) => {
          return {
            ...item,
            isChecked: false,
          };
        }
      );
      setSelectedTpc(updatedData);
    }
  }, []);

  useEffect(() => {
    // if (location?.pathname?.includes(createGroupTopicEditPath)) {
    // }

    setTopicCourseAss(formData?.topicContent?.TopicCourseAssociations);
    setTopicCourseAssTopicId(formData?.topicContent?.TopicCourseAssociations);
  }, [
    location?.pathname,
    formData,
    setTopicCourseAssTopicId,
    setTopicCourseAss,
  ]);
  useEffect(() => {
    if (
      // location?.pathname?.includes(createGroupTopicEditPath) &&
      // topicCourseAssList !== undefined &&
      // topicCourseAssList !== null &&
      // typeof topicCourseAssList === "object" &&
      //Object.keys(topicCourseAssList)?.length !== 0 &&
      selctedAllTopicsIds !== null &&
      selctedAllTopicsIds !== undefined
    ) {
      const updatedData = getAllTopics?.map((item) => {
        if (
          // topicCourseAssList[item?.TopicId || item?.SubTopicId] ||
          // topicCourseAssTopicIdList[item?.SubTopicId || item?.TopicId] ||
          selctedAllTopicsIds[item?.SubTopicId || item?.TopicId]
        ) {
          return {
            ...item,
            isChecked: true,
            disabled: true,
          };
        } else {
          return { ...item, isChecked: false, disabled: false };
        }
      });
      setGetAllTopics(updatedData);
      // let arr = [];
      // getAllTopics?.forEach((item) => {
      //   if (item.isChecked === true) {
      //     arr.push(item);
      //   }
      // });
      // setSelectedTpc(arr);
      // if (location?.pathname?.includes(createGroupTopicEditPath)) {
      //   setSelectedTpc(topicCourseAss);
      // } else {
      //   setSelectedTpc(formData?.topicContent?.TopicCourseAssociations);
      // }
      //const filterData = updatedData?.filter((item) =>  item?.checked)
    }
  }, [
    //dispatch,
    //location?.pathname,
    //topicCourseAssList,
    // //selectedTopicItemsList,
    //topicCourseAssTopicIdList,
    selctedAllTopicsIds,
    selectedTopicItemsIDs,
    //topicCourseAss,
    //setGetAllTopics,
    // topicIds,
    // movedTopicData,
    // selectedTpc?.length,
    // topicIds?.length,
    // callApi,
    getAllTopics?.length,
    // setSelectedTpc,
    // setSeriesShotclassDataAction,
  ]);
  // useEffect(() => {
  //   if(!location?.pathname?.includes(createGroupTopicEditPath)){
  //     setSelectedTpc(formData?.topicContent?.TopicCourseAssociations);
  //   }
  //   else{
  //     setSelectedTpc(topicCourseAss)
  //   }
  // }, [setSelectedTpc])

  // useEffect(() => {
  //   if (
  //     selectedTopicItemsList !== undefined &&
  //     selectedTopicItemsList !== null &&
  //     typeof selectedTopicItemsList === "object" &&
  //     Object.keys(selectedTopicItemsList)?.length !== 0
  //   ) {
  //     const filteredEntries = Object.entries(selectedTopicItemsList).filter(
  //       ([key, value]) => key !== "undefined" && value !== true
  //     );
  //     const filteredSelectedTopicItemsList =
  //       Object.fromEntries(filteredEntries);

  //     const updatedData = getAllTopics?.map((item) => {

  //       if (selectedTopicItemsList.hasOwnProperty(item?.TopicId)) {
  //         debugger;
  //         return {
  //           ...item,
  //           isChecked: true,
  //           disabled: true,
  //         };
  //       } else {
  //         return { ...item, isChecked: false, disabled: false };
  //       }
  //     });
  //     setGetAllTopics(updatedData);
  //   }
  // }, [selectedTopicItemsList]);
  const [elementsSelectedTopic, setElementsSelectedTopic] =
    useState(selectedTpc);
  useEffect(() => {
    setElementsSelectedTopic(selectedTpc);
  }, [selectedTpc]);
  const handleonDrag = (results) => {
    const { source, destination } = results;
    if (!destination) {
      return;
    }
    if (
      source.droppableId === destination.droppableId &&
      source.index === destination.index
    ) {
      return;
    }
    const reorderedStores = [...elementsSelectedTopic];
    const sourceIndex = source.index;
    const destinationIndex = destination.index;
    const [removedElement] = reorderedStores.splice(sourceIndex, 1);
    reorderedStores.splice(destinationIndex, 0, removedElement);
    return setElementsSelectedTopic(reorderedStores);
  };
  const handleSearch = useCallback(
    (e) => {
      setCallApi(false);
      setActiveLoader(true);
      let searchText = e.target.value.trim() !== "" && e.target.value;
      if (searchText) {
        dispatch(
          getAllTopicsAfterSearchActionHandler(
            searchText,
            0,
            pageSize,
            setGetAllTopics
          )
        ).then((response) => {
          const updatedData = response?.map((item) => {
            if (selctedAllTopicsIds.hasOwnProperty(item?.TopicId)) {
              return {
                ...item,
                isChecked: true,
                disabled: true,
              };
            } else {
              return { ...item, isChecked: false, disabled: false };
            }
          });
          setActiveLoader(false);
          setGetAllTopics(updatedData);
        });
      } else {
        setActiveLoader(true);
        dispatch(availableTopicActionHandler("", 0, 8, setGetAllTopics)).then(
          (response) => {
            const updatedData = response?.map((item) => {
              if (selctedAllTopicsIds.hasOwnProperty(item?.TopicId)) {
                return {
                  ...item,
                  isChecked: true,
                  disabled: true,
                };
              } else {
                return { ...item, isChecked: false, disabled: false };
              }
            });
            setGetAllTopics(updatedData);
            setActiveLoader(false);
          }
        );
      }
    },
    [
      // dispatch,
      selectedTopicItemsList,
      setGetAllTopics,
      // topicCourseAssList,
      // getAllTopics,
      // selectedTpc,
      // subTopicItemsList,
      topicIds?.length,
    ]
  );
  // useEffect(() => {
  //   if (topicCourseAssList?.length !== undefined) {
  //     const updatedData = getAllTopics?.map((item) => {
  //       if (topicCourseAssList[item?.TopicId] || item?.SubTopicId) {
  //         return {
  //           ...item,
  //           isChecked: true,
  //           disabled: true,
  //         };
  //       } else {
  //         return { ...item };
  //       }
  //     });
  //     setGetAllTopics(updatedData);
  //   }
  //   if (selectedTopicItemsList?.length !== undefined) {
  //     const updatedData = getAllTopics?.map((item) => {
  //       if (selectedTopicItemsList[item?.TopicId] || item?.SubTopicId) {
  //         return {
  //           ...item,
  //           isChecked: true,
  //           disabled: true,
  //         };
  //       } else {
  //         return { ...item };
  //       }
  //     });
  //     setGetAllTopics(updatedData);
  //   }
  // }, [
  //   topicCourseAssList,
  //   selectedTopicItemsList,
  //   getAllTopics?.length,
  //   selectedTpc?.length,
  //   //location.path,
  //   selectedTpc,
  //   setSelectedTpc,
  // ]);
  // useEffect(() => {
  //   if (selectedTpc?.length > 0 && getAllTopics?.length > 0) {
  //     selectedTpc?.map((item) => {
  //       if (topicIds.indexOf(item.TopicId || item.SubTopicId) === -1) {
  //         topicIds.push(item.TopicId || item.SubTopicId);
  //       }
  //     });
  //   }
  //   if (selectedTpc?.length !== topicIds.length && topicIds?.length > 0) {
  //     const updateRightData = topicIds.filter(
  //       (dataVal) => !movedTopicData.includes(dataVal)
  //     );
  //     setTopicIds(updateRightData);
  //   }
  // }, [selectedTpc?.length, getAllTopics?.length]);
  // useEffect(() => {
  //   if (topicIds?.length > 0 && getAllTopics?.length > 0) {
  //     const update = getAllTopics?.map((item) => {
  //       if (topicIds?.includes(item?.TopicId || item?.SubTopicId)) {
  //         return {
  //           ...item,
  //           isChecked: true,
  //           disabled: true,
  //         };
  //       } else {
  //         return { ...item, isChecked: false, disabled: false };
  //       }
  //     });
  //     setGetAllTopics(update);
  //   }
  // }, [topicIds, selectedTpc?.length, getAllTopics?.length]);
  return formData?.details?.thumbnailImageFile.length == "1" && loader ? (
    <Loader page />
  ) : (
    <div className={classes.topicContentMain}>
      <FormProvider {...methods}>
        {/* <h1 className={classes.title}>Select topic content to create group</h1> */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className={classes.topicFormsMain}>
            <div className={classes.topicContentFormsMain}>
              <div className={classes.availableTopics}>
                <div className={classes.availableTopicsTitle}>
                  {/* Available Topics */}
                  Available
                  {/* <div className={classes.infoIcon}>
                    <Tooltip
                      direction="right"
                      content="Available topics to make group topic"
                    >
                      <InfoIcon />
                    </Tooltip>
                  </div> */}
                </div>
                <div className={classes.topicSearchInput}>
                  <Input
                    label={""}
                    name="tagname"
                    placeholder={"Search Tag or Name"}
                    search
                    width="auto"
                    // value={searchText}
                    // onChange={(event) => {
                    //   setSearchText(event.target.value);
                    // }}
                    onChange={(e) => handleSearch(e)}
                    onKeyDown={(e) => {
                      if (e.keyCode === 13) {
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
                <div className={classes.topicsList}>
                  {/* {} */}
                  {activeLoader ? (
                    <div className={classes.loader}>
                      <Loader height="50" width="50" />
                    </div>
                  ) : getAllTopics?.length === 0 && !activeLoader ? (
                    <div className={classes.noDataFound}>No Topic Found</div>
                  ) : getAllTopics?.length == "0" && callApi ? (
                    <div className={classes.loader}>
                      <Loader height="50" width="50" />
                    </div>
                  ) : getAllTopics?.length > 0 ? (
                    <ul>
                      {getAllTopics?.map((item, index) => {
                        return (
                          <>
                            {item?.IsPublished == true && (
                              <li key={item?.TopicId}>
                                <input
                                  type="checkbox"
                                  name={item?.Name}
                                  value={item?.Name}
                                  width="20px"
                                  height="2"
                                  id={item?.TopicId}
                                  onChange={(e) => {
                                    handleTopics(e, item, index);
                                  }}
                                  disabled={item?.disabled}
                                  checked={item?.isChecked}
                                />
                                <label htmlFor={item?.TopicId}>
                                  {item?.Name}
                                </label>
                              </li>
                            )}
                          </>
                        );
                      })}
                    </ul>
                  ) : (
                    <div className={classes.noDataFound}>No Topic Found</div>
                  )}
                </div>
              </div>
              <div className={classes.nextPrvBtns}>
                <span
                  className={classes.nextBtn}
                  onClick={handleNextBtn}
                  disabled={selectedTopicData.length > 0 ? false : true}
                >
                  <NextIcon fill={"#707070"} />
                </span>
                <span
                  className={classes.prevBtn}
                  onClick={handlePrevBtn}
                  disabled={selectedTpc?.length > 0 ? false : true}
                >
                  <NextIcon fill={"#707070"} />
                </span>
              </div>
              <div className={classes.availableTopics}>
                <div className={classes.availableTopicsTitle}>
                  {/* <FormattedMessage id="SELECTED_CLASSES" /> */}
                  {/* Selected Topics */}
                  Selected
                </div>
                <div
                  className={`${classes.topicsList} ${classes.selectedTopicsList}`}
                >
                  <DragDropContext onDragEnd={handleonDrag}>
                    <Droppable
                      droppableId="selectedTopics"
                      key="selectedTopics"
                      type="selectedTpcTypeBox"
                    >
                      {(provided, snapshot) => {
                        return (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{
                              background: snapshot.isDraggingOver
                                ? "#f3f3f3"
                                : "",
                            }}
                          >
                            <ul>
                              {elementsSelectedTopic.map((item, index) => {
                                return (
                                  <Draggable
                                    key={`SwappingList[${index}]`}
                                    draggableId={`selectedTopic-${index}`}
                                    index={index}
                                  >
                                    {(provided, snapshot) => {
                                      return (
                                        <div
                                          key={item?.ID}
                                          ref={provided.innerRef}
                                          {...provided.draggableProps}
                                          {...provided.dragHandleProps}
                                          style={{
                                            backgroundColor: snapshot.isDragging
                                              ? "#dddddd"
                                              : "",
                                            ...provided.draggableProps.style,
                                          }}
                                        >
                                          <li key={index}>
                                            <input
                                              type="checkbox"
                                              name={
                                                item?.TopicId ||
                                                item?.SubTopicId
                                              }
                                              value={item?.Name}
                                              width="20px"
                                              height="2"
                                              checked={item?.isChecked}
                                              id={
                                                item?.TopicId ||
                                                item?.SubTopicId
                                              }
                                              onChange={(e) => {
                                                handleTrainingContent(e, item);
                                                setValue(
                                                  "training",
                                                  selectedTpc
                                                );
                                              }}
                                              error={errors?.training?.message}
                                            />
                                            <label htmlFor={item?.TopicId}>
                                              {item?.Name}
                                            </label>
                                            <div className={classes.typeCross}>
                                              <span
                                                {...provided.dragHandleProps}
                                              >
                                                <IoMdMove />
                                              </span>
                                            </div>
                                          </li>
                                        </div>
                                      );
                                    }}
                                  </Draggable>
                                );
                              })}
                            </ul>
                          </div>
                        );
                      }}
                    </Droppable>
                  </DragDropContext>
                </div>
              </div>
            </div>

            <div className={classes.topicBtns}>
              <div
                className={classes.clearAll}
                onClick={() => {
                  navigate(
                    `${addGroupTopic.path(
                      location,
                      routerParams,
                      tenantName
                    )}/details`
                  );
                  handleCancelBtn();
                }}
              >
                {/* <FormattedMessage id="USERMANAGE_CANCEL" /> */}
                <FormattedMessage id="PAGINATION_PREVIOUS" />
              </div>
              {/* {selectedTpc.length > 0 && (
                <div className={classes.clearAll} onClick={clearAll}>
                  <FormattedMessage id="CLEAR_ALL_TXT" />Clear All
                </div>
              )} */}
              <Button
                label={<FormattedMessage id="USERMANAGE_BTNSAVE" />}
                small
                dark
                onClick={saveTopic}
                disabled={selectedTpc.length > 0 ? false : true}
                loading={btnLoader}
              />
              <Button
                label={
                  dataForUpdateGroupTopicByID?.[0]?.IsPublished ? (
                    "UnPublish"
                  ) : (
                    <FormattedMessage id="CREATE_PUBLISH_TEXT" />
                  )
                }
                type="submit"
                small
                dark
                disabled={selectedTpc.length > 0 ? false : true}
                onClick={setValue("publishbtn", true)}
                loading={publishBtnLoader}
              />
            </div>
          </div>
        </form>
      </FormProvider>
    </div>
  );
};

export default TopicContent;
